(function () {
  if (customElements.get("apella-size-chart")) return;
  var motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
  class ApellaSizeChart extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector("dialog");
      if (!this.dialog) return;
      this.openers = document.querySelectorAll(
        '[data-size-chart-open="' + this.dialog.id + '"]',
      );
      this.storageKey = this.dataset.storageKey || "apella-size-chart-unit";
      this.onOpen = (event) => {
        this.opener = event.currentTarget;
        this.open();
      };
      this.openers.forEach((opener) => opener.addEventListener("click", this.onOpen));
      this.querySelector("[data-size-chart-close]")?.addEventListener(
        "click",
        () => this.close(),
      );
      this.querySelectorAll("[data-size-chart-unit]").forEach((button) =>
        button.addEventListener("click", () =>
          this.setUnit(button.dataset.sizeChartUnit, true),
        ),
      );
      this.dialog.addEventListener("click", (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.dialog.addEventListener("cancel", (event) => {
        event.preventDefault();
        this.close();
      });
      this.dialog.addEventListener("close", () => {
        this.dialog.classList.remove("is-open", "is-closing");
        document.documentElement.classList.remove("apella-size-chart-open");
        this.opener?.focus();
      });
      var saved = "inch";
      try {
        saved = localStorage.getItem(this.storageKey) || "inch";
      } catch (_) {}
      this.setUnit(saved === "cm" ? "cm" : "inch", false);
    }
    disconnectedCallback() {
      this.openers?.forEach((opener) => opener.removeEventListener("click", this.onOpen));
    }
    open() {
      if (!this.dialog.open) this.dialog.showModal();
      document.documentElement.classList.add("apella-size-chart-open");
      requestAnimationFrame(() => this.dialog.classList.add("is-open"));
    }
    close() {
      if (!this.dialog.open) return;
      this.dialog.returnValue = "dismissed";
      this.dialog.classList.remove("is-open");
      if (motionQuery.matches) {
        this.dialog.close("dismissed");
        return;
      }
      this.dialog.classList.add("is-closing");
      window.setTimeout(() => {
        if (this.dialog.open) this.dialog.close("dismissed");
      }, 220);
    }
    setUnit(unit, persist) {
      this.querySelectorAll("[data-size-chart-unit]").forEach((button) =>
        button.setAttribute(
          "aria-pressed",
          String(button.dataset.sizeChartUnit === unit),
        ),
      );
      this.querySelectorAll("[data-unit-value]").forEach((value) => {
        value.hidden = value.dataset.unitValue !== unit;
      });
      this.dataset.unit = unit;
      if (persist)
        try {
          localStorage.setItem(this.storageKey, unit);
        } catch (_) {}
    }
  }
  customElements.define("apella-size-chart", ApellaSizeChart);
})();
